<script>
	// Stores 
	import { 
		textAtendimento,
		textEndereco, 
		todosContatos,
		textSite, 
		comoChegar
	} from '../store.js';

	let enderecoSimples = $textEndereco.replaceAll('<br class=\'hidden-sm hidden-xs\'>', '');
	let atendimentoSimples = $textAtendimento.replaceAll('<br class=\'hidden-sm hidden-xs\'>', '');

	export let contatos = $todosContatos;
</script>
<section class="contato text-left">
	<div class="flex flex-column gap-10 flex-1 telefones">
		<h3><i class="fas fa-phone color-secondary"></i> Atendimento</h3>
		{#each contatos as contato}
		<div class="phone flex sm-flex-column gap-10 sm-gap-5">
			<a class="color-secondary" target="_blank" href="{contato.href}">{@html contato.icon} {contato.phone} - <span style="font-weight: normal;">{contato.title}</span></a>
		</div>
		{/each}
	</div>
	<hr>
	<h3><i class="fas fa-clock color-secondary"></i> Horário</h3>
	<p>{@html atendimentoSimples}</p>
	<hr>
	<h3><i class="fas fa-map color-secondary"></i> Localização</h3>
	<p>{@html enderecoSimples}</p>
	<div class="flex flex-1 gap-10">
		{#each $comoChegar as l}
		<div class="item">
			<a href="{l.link}" target="_blank" title="{$textSite} via {l.title}">
				{@html l.icon} {l.title} 
			</a>
		</div>
		{/each}
	</div>
</section>